import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { post } from '@/library/axios';
import type { MutationConfig } from '@/library/react-query';
import { displayError } from '@/utils/functions/displayError';

import type { ProductShortKeyType } from './createOneTimeOrder';

export type VerifyPaymentReq = {
  orderId: string;
  paymentId: string;
  secret: string;
  productShortKey: ProductShortKeyType;
};

export const postPaymentDetails = ({
  orderId,
  customerId,
  payload,
}: {
  orderId: string;
  customerId: string;
  payload: VerifyPaymentReq;
}): Promise<any> => {
  // TODO: extract base url into ENV file
  return post(
    `/customers/${customerId}/orders/${orderId}/verification`,
    payload
  );
};

type UsePostPaymentDetails = {
  config?: MutationConfig<typeof postPaymentDetails>;
};

export const usePostPaymentDetails = ({
  config,
}: UsePostPaymentDetails = {}) => {
  const mutation = useMutation({
    ...config,
    mutationFn: postPaymentDetails,
  });

  useEffect(() => {
    displayError(mutation.error);
  }, [mutation.error]);

  return mutation;
};
